import React, { Component } from 'react';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import './AutomaticEditNoChanges.scss';

import { moduleActions } from '../../../redux/modules';
import { AUTOMATIC_EDIT_NO_CHANGES_MADE } from '../../../redux/modules/modals/modals.module';
import { getHasCollegeOnly } from '../../../redux/modules/productTypes/productType.selectors';
import Button from '../../Shared/Button/Button';
import config from '../../../config/config';
import { isIRAAutoMax } from '../../../utils/transactions-util';

class AutomaticEditNoChanges extends Component {
  render() {
    const { closeModal, getHasCollegeOnly } = this.props;
    return (
      <div>
        <div className="automatic-edit-not-changes-title">
          You didn't make any changes to this{' '}
          {getHasCollegeOnly
            ? 'Automatic Monthly Contribution'
            : isIRAAutoMax()
            ? 'IRA AutoMax'
            : 'Automatic Buy'}
          .
        </div>
        <div className="automatic-edit-not-changes-buttons-container">
          <Button
            buttonType="primary"
            id="continue-edit-btn"
            styleName="continue-edit-btn"
            onClick={() => closeModal(AUTOMATIC_EDIT_NO_CHANGES_MADE)}
          >
            Continue Editing
          </Button>
          <a
            onClick={() => this.goToATLP()}
            href={`${config.url}/usis/transactions/automatic`}
            className="college-branded-link automatic-edit-not-changes-stop-edit-link"
          >
            Go Back to Automatic Transactions
          </a>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    getHasCollegeOnly: getHasCollegeOnly(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...moduleActions }, dispatch),
  dispatch,
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  AutomaticEditNoChanges
);
